import request from '@/utils/request'

// export function siteSearchFilterList (entity, search, item) {
//   const method = 'get'
//   const url = `/site`
//   return request({
//     url,
//     method
//   })
// }

export function protocolCountries (protocol_id) {
  const method = 'get'
  let url = `/protocol_countries/${protocol_id}`
  return request({
    url,
    method
  })
}